var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTheMicroneedlingFacial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24.4844,
    r: 24,
    fill: "#A0CFDC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2244 41.3159C33.3952 41.3159 40.8296 33.8815 40.8296 24.7107C40.8296 15.5399 33.3952 8.10547 24.2244 8.10547C15.0536 8.10547 7.61914 15.5399 7.61914 24.7107C7.61914 33.8815 15.0536 41.3159 24.2244 41.3159Z",
    stroke: "#0F2A59",
    strokeWidth: 1.104,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.21 3.84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2244 34.7984C29.7957 34.7984 34.3121 30.282 34.3121 24.7107C34.3121 19.1395 29.7957 14.623 24.2244 14.623C18.6531 14.623 14.1367 19.1395 14.1367 24.7107C14.1367 30.282 18.6531 34.7984 24.2244 34.7984Z",
    stroke: "#0F2A59",
    strokeWidth: 1.104,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.21 3.84"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.221 28.2779C26.1908 28.2779 27.7876 26.681 27.7876 24.7112C27.7876 22.7414 26.1908 21.1445 24.221 21.1445C22.2511 21.1445 20.6543 22.7414 20.6543 24.7112C20.6543 26.681 22.2511 28.2779 24.221 28.2779Z",
    fill: "#0F2A59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheMicroneedlingFacial);
export default __webpack_public_path__ + "static/media/the-microneedling-facial.58b269fc582b5b708718124cf5ab36a6.svg";
export { ForwardRef as ReactComponent };